import { SearchResults } from 'algoliasearch-helper';

import type {
  Item,
  MergeFiltersByAlias,
} from '@/domains/productDiscovery/Listings/components/Filters/components/MultiSelect/interfaces';
import { MergedValue } from '@/domains/productDiscovery/microservices/msfProductListing/interfaces/microservice';

export const generateItemsFromFacet = (
  values: SearchResults.FacetValue[] = [],
  facetName: string,
  mergedValues?: MergedValue[],
): Item[] | [] => {
  const mergedFilters: MergeFiltersByAlias = {};
  const filters = values
    .map(({ name, count, isRefined }) => {
      let isMerged = false;

      // Merged filters exception
      // Loop on the merge list filters to find out if the current filter should be merged
      mergedValues?.forEach((item) => {
        if (item.names?.includes(name)) {
          // Set the current filter in a temporary storage object
          mergedFilters[item.alias] = {
            id: facetName,
            value: `${(mergedFilters[item.alias]?.value && `${mergedFilters[item.alias]?.value},`) || ''}${name}`,
            count: (mergedFilters[item.alias]?.count || 0) + count,
            label: item.alias,
            isRefined: mergedFilters[item.alias]?.isRefined || isRefined,
          };

          isMerged = true;
        }
      });

      // Return the current filter if it's not merged
      if (!isMerged) {
        return {
          id: facetName,
          value: name,
          count,
          label: name,
          isRefined,
        };
      }
    })
    .filter(Boolean) as Item[];

  // Return all sorted filters by descending products count
  const allFilters = [...Object.values(mergedFilters), ...filters].sort(
    (a, b) => b.count - a.count,
  );

  return allFilters;
};
